<script>
import { http } from '@/system/http.js';
import TextareaAutosize from '@/system/components/global/form/TextareaAutosize';
import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
import Switchery from '@/system/components/global/form/Switchery.vue';
import CustomClientFieldsContainer from '@/system/components/apps/custom_client_fields/CustomClientFieldsContainer';
import PhoneNumberInput from '@/system/components/global/form/PhoneNumberInput';
import ClientForm from '@/online_booking/new/components/common_booking/ClientForm.vue'
import moment from 'moment';
import Card from '@/online_booking/new/components/common/Card';
import { mapActions, mapGetters, mapState } from 'vuex';
import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
import StepCounter from '@/online_booking/new/components/common/StepCounter';
import BookingFlowStep from '@/online_booking/new/BookingFlowStep.js';
import EpButton from '@/system/components/global/button';
import { appendCustomAttributesToFormData } from '@/system/helpers';
import { bookingKeys } from '@/online_booking/new/helpers/constants';

export default {
    mixins: [hasSelectedProducts],

    data() {
        return {
            loading: false,
            logged_in_client: null,
            calendar: null,
            permalink: null,
            voucher: null,
            selected_date: null,
            time: null,
            online_booking_settings: {},
            user: {},
            field_settings: {},
            notes_text: "",
            isWaitingList: false,
            giftcard_code: giftcard_identifier_in_url,
            discount_code_code: '',
            is_giftcards_active: false,
            is_discount_codes_active: false,
            giftcards_settings: false,
            fullDaySignup: 0,
            danmark: 0,
            custom_client_fields: [],
            custom_attributes: {},
            first_step: null,
            second_step: null,
            form: {
                name: '',
                email: '',
                phone: '',
                address: '',
                address_line_2: '',
                zip: '',
                city: '',
                zone: '',
                country: '',
                cpr: '',
                dob: '',
                notes: '',
            }
        }
    },

    mounted() {
        this.$event_bus.$on('voucherClicked', (voucher) => {
            this.discount_code_code = '';
            this.voucher = voucher;
            this.triggerStateChange()
        });

        this.$event_bus.$on('CalendarClicked', (calendar) => {
            this.calendar = calendar;

            if (
                (this.waitingListOnly && this.second_step === BookingFlowStep.Calendar)
                || this.second_step === BookingFlowStep.Times
            ) {
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#choose-time-panel').offset().top});
                    }, 250);
                }

                this.triggerStateChange()
            }
        });

        this.$event_bus.$on('bookSoonest', (soonestData) => {
            this.calendar = soonestData.calendar;
            this.selected_date= moment(soonestData.formattedDate);
        });

        this.$event_bus.$on('timeSet', (time, fullyBooked, waitingListSelected) => {
            this.isWaitingList = waitingListSelected;
            this.time = waitingListSelected ? time : time.date;
            this.fullDaySignup = 0

            if (!this.second_step || this.second_step !== BookingFlowStep.Times) {
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#choose-time-panel').offset().top});
                    }, 250);
                }

                this.triggerStateChange()
            }
        });

        this.$event_bus.$on('productsChosen', () => {
            if (this.waitingListOnly && this.second_step === BookingFlowStep.Products) {
                this.isWaitingList = true;

                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#choose-time-panel').offset().top});
                    }, 250);
                }

                this.triggerStateChange()
            }
        });

        this.$event_bus.$on('preferredTimeSet', (selected_time, fullDaySignup, comments, fullyBooked, waitingListSelected) => {
            this.isWaitingList = waitingListSelected;
            this.fullDaySignup = fullDaySignup;
            this.time = selected_time;

            if (!this.second_step || this.second_step !== BookingFlowStep.Times) {
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#choose-time-panel').offset().top});
                    }, 250);
                }

                this.triggerStateChange()
            }
        });

        this.$event_bus.$on('LoadData', (data) => {
            this.permalink = data.permalink;
            this.logged_in_client = data.logged_in_client;
            this.online_booking_settings = data.online_booking_settings;
            this.user = data.user;
            this.field_settings = data.online_booking_settings.fields;
            this.is_giftcards_active = data.is_giftcards_active;
            this.giftcards_settings = data.giftcards_settings;
            this.is_discount_codes_active = data.is_discount_codes_active;
            this.custom_client_fields = data.custom_client_fields;
            this.first_step = data.online_booking_settings.first_step;
            this.second_step = data.online_booking_settings.second_step;

            if(this.online_booking_settings.address_field === "on") {
                this.form.country = this.user.country;
            }

            if (this.logged_in_client) {
                this.custom_attributes = {...this.logged_in_client.custom_attributes};
            }

            // to make sure sidebar has the details of the client if they are logged in
            this.setSelectedValue({
                key: bookingKeys.FILL_INFORMATION,
                value: data.logged_in_client ? data.logged_in_client.name : ''
            });
        });

        this.$event_bus.$on('dateClicked', (dates) => {
            this.selected_date = dates.selected;
        });

        this.$event_bus.$on('VouchersShowed', () => {
            $('#collapseFillInfo').collapse('hide'); // todo: remove this if not used
        });

        this.$event_bus.$on('ClientLoggedIn', (data) => {
            this.logged_in_client = data.logged_in_client;
            this.user = data.user;
        });
    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

        infoAdded() {
            this.errors.clear();
            this.loading = true;
            const dataFrm = new FormData($('#fill-info-frm')[0]);

            Object.keys(this.form).forEach((property) => {
                dataFrm.append(property, this.form[property])
            })

            if (this.voucher) {
                dataFrm.append('voucher', this.voucher.id);
            } else {
                dataFrm.append('date_time', moment(this.time).format('YYYY-MM-DD HH:mm'));
                dataFrm.append('calendar', this.calendar.id);


                this.selectedProducts.forEach((product, index) => {
                    dataFrm.append(`products[${index}][product_id]`, product.product ? product.product.id : product.id);
                    dataFrm.append(`products[${index}][voucher_id]`, product.product ? product.id : 0);
                    dataFrm.append(`products[${index}][client_voucher_id]`, product.product ? product.id : 0);

                    product.selectedAddons.forEach((addon, addonIndex) => {
                        dataFrm.append(`products[${index}][addons][${addonIndex}][addon_product_id]`, addon.id);
                    });
                });
            }

            appendCustomAttributesToFormData(dataFrm, this.custom_attributes);

            if (this.giftcard_code !== '') {
                dataFrm.append('giftcard_code', this.giftcard_code);
            }

            if (this.discount_code_code != '') {
                dataFrm.append('discount_code', this.discount_code_code);
            }

            http.post('/book/' + this.permalink + '/is-choose-client', dataFrm)
                .then(({ data }) => {
                    var confirmInfo = null;
                    if (this.logged_in_client) {
                        confirmInfo = {
                            name: this.logged_in_client.name,
                            email: this.logged_in_client.email,
                            phone: this.logged_in_client.phone,
                            address: this.logged_in_client.address,
                            address_line_2: this.logged_in_client.address_line_2,
                            zip: this.logged_in_client.zip,
                            city: this.logged_in_client.city,
                            zone: this.logged_in_client.zone,
                            country: this.logged_in_client.country,
                            notes: this.form.notes,
                            dob: this.form.dob,
                        };
                    } else {
                        confirmInfo = Object.assign({}, this.form)
                    }

                    if (data.giftcard) {
                        this.$store.commit('setGiftcard', data.giftcard);
                    }

                    if (data.discount_code) {
                        this.$store.commit('setDiscountCode', data.discount_code);
                    }

                    if (data.choose_client) {
                        this.$event_bus.$emit('chooseUser', {dataFrm: dataFrm, clients: data.clients, confirmInfo: confirmInfo, waitingListSelected : this.isWaitingList});
                    } else {
                        dataFrm.append('client', data.client);
                        this.$event_bus.$emit('confirm', { dataFrm: dataFrm, confirmInfo: confirmInfo, isWaitingList: this.isWaitingList });
                    }
                    this.loading = false;
                })
                .catch(({error, errorBag}) => {
                    this.loading = false;
                    if (errorBag) {
                        this.$setErrorBag(errorBag);

                        if (errorBag.items && errorBag.items.length > 0) {
                            let fieldName = errorBag.items[0].field.split('.').pop();
                            $('[name=' + fieldName + ']')[0].scrollIntoView();
                            $('[name=' + fieldName + ']').focus();
                        }
                    }
                });
        },

        triggerStateChange () {
            if (this.loginAtTheEndOfFlow && !this.loggedInClient) {
                this.setCurrentStep('login');
            } else {
                this.setCurrentStep('fillInformation');
            }
        }
    },
    computed: {
        ...mapState('OnlineBooking', ['currentStep', 'loginAtTheEndOfFlow', 'loggedInClient']),
        ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount', 'waitingListOnly']),

        hasServiceGiftcardApplied() {
            return this.giftcard !== null && this.giftcard.product_id !== null;
        },

        isBuyVouchersPage(){
            return this.$route.name === 'buy-vouchers';
        },

        showEmail() {
            return (this.logged_in_client && this.field_settings.email_required && !this.logged_in_client.email) || (!this.logged_in_client && this.field_settings.email);
        },

        showPhone() {
            return (this.logged_in_client && this.field_settings.phone_required && !this.logged_in_client.phone) || (!this.logged_in_client && this.field_settings.phone);
        },

        showAddress() {
            return (this.logged_in_client && this.field_settings.address_required && !this.logged_in_client.address) || (!this.logged_in_client && this.field_settings.address);
        },

        showCustomFields() {
            return this.custom_client_fields.some(
                field => field.required_in_online_booking
                    || field.show_in_online_booking
            );
        },

        showSocialSecurity() {
            if (this.user.online_payment_settings && this.user.online_payment_settings.allow_sygeforsikring_danmark_submission && (!this.logged_in_client || !this.logged_in_client.is_in_sygeforsikring_danmark_group) && this.user.is_sygeforsikring_danmark_connected) {
                return true;
            } else if ((this.logged_in_client && this.field_settings.cpr_required && !this.logged_in_client.cpr) || (!this.logged_in_client && this.field_settings.cpr)) {
                return true;
            } else {
                return false;
            }
        },

        socialSecurityRequired() {
            return Boolean(this.online_booking_settings.fields.cpr_required || (this.user.is_sygeforsikring_danmark_connected && this.danmark));
        },

        showDateOfBirth() {
            return (this.logged_in_client && this.field_settings.dob_required && !this.logged_in_client.dob) || (!this.logged_in_client && this.field_settings.dob);
        },

        showDanmarkGroups() {
            var show_danmark =  (this.user.online_payment_settings && this.user.online_payment_settings.allow_sygeforsikring_danmark_submission && (!this.logged_in_client || !this.logged_in_client.is_in_sygeforsikring_danmark_group) && this.user.is_sygeforsikring_danmark_connected);

            if(!show_danmark && this.user.is_sygeforsikring_danmark_connected && this.field_settings.danmark){
                return true;
            }

            return show_danmark;
        },

        isFillInformationStepActive () {
            return this.currentStep === 'fillInformation';
        },
    },

    components: {
        StepCounter,
        ClientForm,
        TextareaAutosize,
        Switchery,
        CustomClientFieldsContainer,
        PhoneNumberInput,
        Card,
        PreviousButton,
        EpButton,
    },

    watch: {
        isFillInformationStepActive (newValue) {
            if (newValue) {
                window.location.hash = 'your-details';
                if (!this.hasServiceGiftcardApplied || !this.selectedProductIds.includes(this.giftcard?.product_id)) {
                    this.$store.commit('removeGiftcard');
                }
                this.$store.commit('removeDiscountCode');
                this.$event_bus.$emit('FillInfoShowed');
            }
        },

        'form.name' (newValue) {
            // to make sure sidebar has the details of the client if they are NOT logged in
            this.setSelectedValue({
                key: bookingKeys.FILL_INFORMATION,
                value: newValue ? newValue : '',
            });
        },
    },
};


</script>


<template>
    <div class="fill-information-container" v-show="isFillInformationStepActive">
        <form id="fill-info-frm" role="form" @submit.prevent="infoAdded()">
            <card class="p-0 overflow-hidden rounded-lg" id="fill-information-panel">
                <h4 class="section-title">
                    <step-counter :current="currentStepNumber" :total="totalStepCount" />
                    {{ trans('online_booking.sidebar.your_details') }}
                </h4>

                <div
                    id="collapseFillInfo"
                    role="tabpanel"
                    aria-labelledby="headingFillInfo"
                    data-parent="#booking-accordion"
                >
                    <div class="pb-0 panel-body" id="information-body-booking">
                        <div class="row">
                            <div class="col-xs-12">
                                <!-- Alert - Already logged in -->
                                <ep-banner class="mb-6" v-if="logged_in_client">
                                    <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                    <span>{{ trans('online_booking.logged_in_as') }}</span>&nbsp;<strong>{{ logged_in_client.name }}</strong>
                                </ep-banner>

                                <!-- End of Alert -->

                                <div v-if="isBuyVouchersPage" class="m-b-20" style="margin-top: -20px;"> <small ><br>
                                    <template v-if="voucher && voucher.is_for_events"> {{ trans('vouchers.vouchers_buy_explanation_events') }}</template>
                                    <template v-else> {{ trans('vouchers.vouchers_buy_explanation') }}</template>
                                </small></div>

                                <client-form
                                    class="online-booking-client-form"
                                    v-if="online_booking_settings.fields"
                                    v-model="form"
                                    :nameOptions="{ display: !logged_in_client, required: true}"
                                    :emailOptions="{ display: showEmail, required: online_booking_settings.fields.email_required}"
                                    :phoneOptions="{ display: showPhone, required: online_booking_settings.fields.phone_required, dropdownParent: '#fill-info-frm'}"
                                    :addressOptions="{ display: showAddress, required: online_booking_settings.fields.address_required, countrySelectParent: 'fill-info-frm'}"
                                    :cprOptions="{ display: showSocialSecurity, required: socialSecurityRequired}"
                                    :dobOptions="{ display: showDateOfBirth, required: online_booking_settings.fields.dob_required}"
                                    :validationErrors="errors"
                                    show-required-indicator
                                >
                                </client-form>

                                <template v-if="showCustomFields">
                                    <custom-client-fields-container context="online_booking" :custom-fields="custom_client_fields" :validation-errors="errors" errors-prefix="custom_attributes" v-model="custom_attributes"></custom-client-fields-container>
                                </template>

                                <div class="form-group" v-if="showDanmarkGroups">
                                    <label for="">Sygeforsikringen "danmark"</label>
                                    <switchery text='Er du medlem af Sygeforsikringen "danmark"?' :name="'danmark'" v-model.number="danmark" :light="true" active-color="var(--brand-primary)"></switchery>
                                </div>

                                <div class="form-group" :class="{ 'has-error' : errors.has('notes') }" v-if="online_booking_settings.notes_field">
                                    <label class="control-label">{{ trans('online_booking.fill_notes') }} <span class="text-danger" v-show="field_settings.notes_required">*</span></label>

                                    <textarea-autosize id="notes" class="form-control" name="notes" rows="2" v-model="form.notes"  style="height: 64px;" :required="field_settings.notes_required"></textarea-autosize>
                                    <span v-if="errors.has('notes')" class="help-block m-b-0">
                                    {{ errors.first('notes') }}
                                    </span>

                                </div>

                                <div
                                    class="form-group"
                                    :class="{ 'has-error' : errors.has('discount_code') }"
                                    v-if="is_discount_codes_active && !isWaitingList && !hasServiceGiftcardApplied"
                                >
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <i class="fa fa-tag m-r-5"></i>
                                            {{ trans('discount_codes.discount_code') }}
                                        </div>

                                        <input
                                            class="form-control"
                                            name="discount_code"
                                            type="text"
                                            v-model="discount_code_code"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <span class="help-block m-b-0" v-if="errors.has('discount_code')">
                                        {{ errors.first('discount_code') }}
                                    </span>
                                    <small class="text-muted" v-else>{{ trans('discount_codes.input_description') }}</small>

                                </div>

                                <div
                                    class="form-group"
                                    :class="{ 'has-error' : errors.has('giftcard_code') }"
                                    v-if="is_giftcards_active && user.giftcards_settings.enabled_online_booking && !isWaitingList && !hasServiceGiftcardApplied"
                                >
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <i class="zmdi zmdi-card-giftcard m-r-5"></i>{{ trans('giftcards.giftcard_code') }}
                                        </div>
                                        <input id="giftcardinput" class="form-control" type="text" name="giftcard_code" v-model="giftcard_code" autocomplete="off">
                                    </div>
                                    <small class="text-muted">{{ trans('giftcards.input_description') }}</small>
                                    <span v-if="errors.has('giftcard_code')" class="help-block m-b-0">{{ errors.first('giftcard_code') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap justify-between gap-6 p-6 pt-0">
                    <previous-button :previous-step-id="getPreviousStepId" />
                    <ep-button
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                        v-if="hasSelectedProducts || voucher"
                    >
                        <span class="hidden sm:inline">{{ trans('online_booking.continue_to_confirmation') }}</span>
                        <span class="sm:hidden">{{ trans('global.continue') }}</span>
                        <i class="ml-3 zmdi zmdi-arrow-right"></i> <!-- todo: replace with the prop -- `end-icon` once font awesome feature goes live -->
                    </ep-button>
                </div>
            </card>
        </form>
    </div>
</template>
